module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-Light.4f0fb504.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-Light.woff2
// module id = 512
// module chunks = 0